import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=8a8f3672&scoped=true&"
import script from "./attachments.vue?vue&type=script&lang=ts&"
export * from "./attachments.vue?vue&type=script&lang=ts&"
import style0 from "./attachments.vue?vue&type=style&index=0&id=8a8f3672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8f3672",
  null
  
)

export default component.exports